exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#ref-identity-button.ref {\r\n\tdisplay: block !important;\r\n}", ""]);

